var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"positions"},[_c('ul',{staticClass:"position-list"},_vm._l((_vm.positionList),function(ref){
var label = ref.label;
var img = ref.img;
var imgSrc = ref.imgSrc;
return _c('li',{key:img,staticClass:"position-item"},[_c('img',{staticClass:"position-img",style:([img == '1.png' ? _vm.compCssStyles : {}]),attrs:{"src":imgSrc,"alt":"#"}}),_c('p',{staticClass:"position-lable text-md"},[_vm._v(_vm._s(_vm._f("toUpper")(_vm._f("trim")(label))))])])}),0),_c('v-annotation',[_vm._v(" "+_vm._s(_vm.dic.sectionPositions.msg1)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }